import { useDispatch, useSelector } from 'react-redux';
import style from './FreeUserBurgerMenu.module.css';
import { useState } from 'react';
import { selectUser } from '../../../../redux/auth/selectors';
import useWebSocket from '../../../../hooks/useWebSocket2';
import { useNavigate } from 'react-router-dom';
import { logOut } from '../../../../redux/auth/operations';
import { Menu } from 'antd';
import { FaPowerOff } from 'react-icons/fa';

const freeUserItems = [
  {
    label: 'Profile',
    key: '/free-user/profile',
  },
  {
    label: 'Create Post',
    key: '/free-user/create-post',
  },
  {
    label: 'Paid Content',
    key: '/free-user/private-media',
  },
  {
    label: 'Live Chat',
    key: '/free-user/live-chat',
  },
  // {
  //   label: 'Live Chat Bot',
  //   key: '/free-user/live-chat-sender',
  // },
  // {
  //   label: 'Mail Sender',
  //   key: '/free-user/mail-sender',
  // },

  {
    label: 'MailBox',
    key: 'mailbox',

    children: [
      {
        label: 'New Letter',
        key: '/free-user/letters/new-letter',
      },
      {
        label: 'Inbox',
        key: '/free-user/letters/inbox',
      },
      {
        label: 'Outbox',
        key: '/free-user/letters/outbox',
      },
      {
        label: 'Primary',
        key: '/free-user/letters/primary',
      },
      {
        label: 'Spam',
        key: '/free-user/letters/spam',
      },
      {
        label: 'Trash',
        key: '/free-user/letters/trash',
      },
    ],
  },
  {
    label: 'Soulmates',
    key: 'soulmates',

    children: [
      {
        label: 'Online Soulmates',
        key: '/free-user/online-soulmates',
      },
      {
        label: 'Fans',
        key: '/free-user/fans',
      },

      {
        label: 'Matches',
        key: '/free-user/matches',
      },
    ],
  },
  {
    label: 'Gifts List',
    key: '/free-user/gifts-list',
  },
];

const FreeUserBurgerMenu = ({ close }) => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  const { sendData } = useWebSocket();

  const navigate = useNavigate();
  const handleClick = ({ key }) => {
    navigate(key);
    close();
  };

  const handleLogOutClick = () => {
    sendData({ id: user._id }, 'removeOnlineUser');
    dispatch(logOut());
    close();
  };

  return (
    <div className={style.menuContainer}>
      <Menu
        onClick={handleClick}
        className={style.menu}
        defaultSelectedKeys={['1']}
        defaultOpenKeys={['sub1']}
        mode="inline"
        theme="dark"
        items={freeUserItems}
      />
      <button className={style.logoutButton} onClick={handleLogOutClick}>
        <FaPowerOff className={style.logoutIcon} />
        Log Out
      </button>
    </div>
  );
};

export default FreeUserBurgerMenu;
